module.exports = __webpack_public_path__ + "static/media/3_13.023e3faf.png";